import { AppSpan, AppText, Button, CustomContainer, FlexColumn } from "src/style"
import InfoIcon from 'src/assets/svg/info'
import { AppCenterPopup, CenterPopupHeader } from "src/component"

export const ReviewingLoanEligibility: React.FC<any> = ({handleNext, close}) => {

    return (
        <AppCenterPopup close={close} zIndex='6' height='42'>
            <CenterPopupHeader icon={<div/>} close={close} />
            <CustomContainer height="41" className='popup-content-container'>
                <CustomContainer topMargin="1.5">
                    <AppText textSize="2.2" fontWeight="700" color="#000000" align="center" bottomMargin="1.5">
                    Sorry, you are not Eligible
                    </AppText>
                      <FlexColumn topMargin="2" bottomMargin="2" >
                    <InfoIcon />
                    </FlexColumn>
                    <AppSpan>
                    Sorry, your application could not proceed because you didn’t
                    pass credit eligibility check, please try again later</AppSpan>
                  
                    <Button 
                        width='100' sizeUnit='%' topMargin='2' bottomMargin="1" 
                        borderColor='#0D968F' hoverBgColor='#fff' 
                        hoverColor='#0D968F'
                        onClick={close}
                    >
                        Go Back
                    </Button>
                    {/* <Button 
                        width='100' sizeUnit='%' topMargin='2' bottomMargin="1" 
                        borderColor='#0D968F' hoverBgColor='#fff' 
                        hoverColor='#0D968F'
                        onClick={handleNext}
                    >
                        Continue
                    </Button> */}
                </CustomContainer>
            </CustomContainer>
        </AppCenterPopup>
    )
}